import React from "react";

const Button = ({ text, className, onClick, icon: Icon, style }) => {
  return (
    <button
      type="button"
      className={`inline-flex items-center ${className}`} // Ensure alignment with flex
      onClick={onClick}
      style={style} // Apply the style prop here
    >
      {Icon && (
        <span className="mr-[9px] max-xs:mr-[5px] ">
          <Icon className="max-xs:w-4" /> {/* Render the SVG */}
        </span>
      )}
      {text}
    </button>
  );
};

export default Button;
